import { render, staticRenderFns } from "./edit.vue?vue&type=template&id=3aa6fdb2&scoped=true&"
var script = {}
import style0 from "./edit.vue?vue&type=style&index=0&id=3aa6fdb2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aa6fdb2",
  null
  
)

export default component.exports